import { render, staticRenderFns } from "./PlayAmountLimitForm.vue?vue&type=template&id=279f8512&scoped=true"
import script from "./PlayAmountLimitForm.vue?vue&type=script&lang=js"
export * from "./PlayAmountLimitForm.vue?vue&type=script&lang=js"
import style0 from "./PlayAmountLimitForm.vue?vue&type=style&index=0&id=279f8512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279f8512",
  null
  
)

export default component.exports